import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import { connect } from 'react-redux'
import {
  cancelTransfer,
  closeAvailRoomsDialog,
  getRoomsForTransfer,
  moveVisitsFinal,
  setRoomTransferMode,
  saveTransferredVisits,
  selectAvailableRoom,
  showtotalAvailableRooms
} from '../redux/modules/roomTransferModule'
import Select from 'react-select'
import Input from './elements/input'
import { Modal, Button, Checkbox } from 'react-bootstrap'
import { renderRoom } from '../components/formatters/roomFormatter'
import LoadingSpinner from '../components/loader'
import DashboardRow from './dashboard/dashboardRow'
import moment from 'moment'
import {
  dashboardStartDateSelector,
  dashboardEndDateSelector,
  filteredRoomsSelector,
  eventsByRoomSelector
} from '../redux/selectors/dashboardSelectors'
import { sortBy } from 'lodash'

function staticProps(state) {
  return {
    show: state.roomTransfer.showDialog,
    selectedRoom: state.roomTransfer.currentlySelectedRoom,
    cleanRoomsList:
      state.roomTransfer.totalAvailableRooms.list.length > 0 &&
      state.roomTransfer.totalAvailableRooms.list.filter(
        item => item.isClean === true
      ),
    totalAvailableRoomsStatus: state.roomTransfer.totalAvailableRooms.status,
    totalAvailableRoomsList: state.roomTransfer.totalAvailableRooms.list,
    isLoading: state.roomTransfer.isLoading,
    isVistsMovedLoading: state.roomTransfer.isVistsMovedLoading,
    selectVisitsFromSameRoom: state.roomTransfer.selectVisitsFromSameRoom,
    newRoomSelected: state.roomTransfer.newRoomSelected,
    roomTransferSuccess: state.roomTransfer.roomTransferSuccess,
    roomTransferMode: state.roomTransfer.roomTransferMode,
    startDate: dashboardStartDateSelector(state),
    endDate: dashboardEndDateSelector(state),
    filteredRooms: filteredRoomsSelector(state),
    eventsByRoom: eventsByRoomSelector(state)
  }
}

@autobind
class TransferRoomsDialog extends Component {
  SelectInput = ({ label, ...otherProps }) => {
    return (
      <Input label={label}>
        <Select {...otherProps} />
      </Input>
    )
  }

  render() {
    const {
      show,
      selectedRoom,
      cleanRoomsList,
      totalAvailableRoomsStatus,
      totalAvailableRoomsList,
      isLoading,
      isVistsMovedLoading,
      selectVisitsFromSameRoom,
      newRoomSelected,
      roomTransferSuccess,
      roomTransferMode,
      startDate,
      endDate,
      filteredRooms,
      eventsByRoom
    } = this.props
    const availableRoomsListArray =
      sortBy(
        Object.values(
          totalAvailableRoomsStatus ? totalAvailableRoomsList : cleanRoomsList
        ).map(item => {
          return {
            name: item.name,
            value: item.id,
            isClean: item.isClean,
            type: item.type
          }
        }),
        ['name', 'value']
      ) || []

    const datesToDisplay = moment.range(startDate, endDate)

    const currentRoom = filteredRooms.find(room => room.id === selectedRoom)

    const weekContentFn = date => {
      return moment(date).format('dd')
    }

    const cellContentFn = date => {
      return date.date()
    }

    return show ? (
      <div>
        <Modal
          show={show}
          onHide={() => {
            this.props.dispatch(closeAvailRoomsDialog())
          }}
          id='transfer-room-modal'
        >
          <Modal.Header closeButton>
            <Modal.Title>Available Rooms</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectVisitsFromSameRoom ? (
              <div>
                {roomTransferSuccess === 'success' ? (
                  <div style={{ color: 'green' }}>
                    The selected visits have been transferred successfully
                  </div>
                ) : roomTransferSuccess === 'error' ? (
                  <div style={{ color: 'red' }}>
                    There was an error while transferring the visits
                  </div>
                ) : (
                  <div>
                    <div
                      className='room-transfer-radio-group'
                      style={{ marginBottom: '20px' }}
                    >
                      <p style={{ fontWeight: 'bold' }}>
                        Please select the mode of transfer
                      </p>
                      <div
                        style={{
                          display: 'flex',
                          gap: '8px',
                          alignItems: 'center'
                        }}
                      >
                        <input
                          type={'radio'}
                          id='transfer-room-option'
                          name='room-transfer-options'
                          value={'room-transfer'}
                          onClick={() => {
                            this.props.dispatch(
                              setRoomTransferMode('room-transfer')
                            )
                            this.props.dispatch(getRoomsForTransfer())
                          }}
                          checked={roomTransferMode === 'room-transfer'}
                        />
                        <label htmlFor='transfer-room-option'>
                          Transfer to an empty room
                        </label>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          gap: '8px',
                          alignItems: 'center'
                        }}
                      >
                        <input
                          type={'radio'}
                          id='swap-room-option'
                          name='room-transfer-options'
                          value={'room-swap'}
                          onClick={() => {
                            this.props.dispatch(
                              setRoomTransferMode('room-swap')
                            )
                            this.props.dispatch(getRoomsForTransfer())
                          }}
                          checked={roomTransferMode === 'room-swap'}
                        />
                        <label htmlFor='swap-room-option'>Swap rooms</label>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        gap: '30px',
                        alignItems: 'center',
                        marginBottom: '15px'
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          gap: '5px',
                          alignItems: 'center'
                        }}
                      >
                        <Checkbox
                          style={{ margin: '0' }}
                          onChange={() => {
                            this.props.dispatch(
                              showtotalAvailableRooms(totalAvailableRoomsStatus)
                            )
                          }}
                        />
                        <p style={{ margin: '0' }}>Show dirty rooms</p>
                      </div>
                      <div>
                        {isLoading && (
                          <LoadingSpinner
                            style={{
                              width: '10em',
                              float: 'left',
                              display: 'block'
                            }}
                          />
                        )}
                      </div>
                    </div>
                    <div style={{ maxWidth: '240px' }}>
                      {!newRoomSelected && (
                        <p style={{ color: 'red' }}>Please select a room</p>
                      )}
                      <this.SelectInput
                        label={'Rooms'}
                        placeholder='Choose a room...'
                        value={selectedRoom}
                        valueRenderer={renderRoom}
                        options={availableRoomsListArray}
                        optionRenderer={renderRoom}
                        clearable={false}
                        onChange={selectedRoom => {
                          this.props.dispatch(selectAvailableRoom(selectedRoom))
                        }}
                      />
                    </div>

                    {currentRoom && (
                      <table className='dashboard-table'>
                        <tbody>
                          <DashboardRow
                            room={{ name: '', isClean: true, id: 'weekRow' }}
                            datesToDisplay={datesToDisplay}
                            events={[]}
                            cellContentFn={weekContentFn}
                          />
                          <DashboardRow
                            room={currentRoom}
                            datesToDisplay={datesToDisplay}
                            events={eventsByRoom[currentRoom.id] || []}
                            cellContentFn={cellContentFn}
                          />
                        </tbody>
                      </table>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div>
                  {isLoading && (
                    <LoadingSpinner
                      style={{
                        width: '10em',
                        float: 'left',
                        display: 'block'
                      }}
                    />
                  )}
                </div>
                <p style={{ color: 'red', margin: '0' }}>
                  Please select the visits from the same room
                </p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '10px'
            }}
          >
            <Button
              bsStyle='primary'
              onClick={() => {
                this.props.dispatch(closeAvailRoomsDialog())
              }}
            >
              Close
            </Button>
            {selectVisitsFromSameRoom &&
              roomTransferSuccess === 'initial' &&
              (isVistsMovedLoading ? (
                <div>
                  <LoadingSpinner />
                </div>
              ) : (
                <Button
                  bsStyle='success'
                  onClick={() => {
                    selectedRoom !== null &&
                      this.props.dispatch(moveVisitsFinal())
                    this.props.dispatch(saveTransferredVisits())
                    this.props.dispatch(cancelTransfer())
                  }}
                  disabled={selectedRoom === null}
                >
                  Save
                </Button>
              ))}
          </Modal.Footer>
        </Modal>
      </div>
    ) : null
  }
}

export default connect(staticProps)(TransferRoomsDialog)



// WEBPACK FOOTER //
// ./src/components/transferRoomsDialog.js